<template>
    <div id="top-page" :class="['content-wrap', this.source]">
        <div class="title">
            <Back/>
            <span>答题排行榜</span>
        </div>
        <Tabs v-model="tabActive" :class="[source]">
            <Tab
                v-for="item in tabs"
                :key="item.label"
                :title="typeof item === 'function' ? item.label('南磨房乡') : item.label"
            >
                <div class="top-content">
                    <div class="time-picker" v-if="item.timePicker">
                        <div class="time-picker-content">
                            <div :class="['left', 'icon-arrow', !monthIndex && 'disabled']" @click="() => handleChangeSeletor(-1)"></div>
                            <div class="time">{{time ? time.text : ''}}</div>
                            <div :class="['right', 'icon-arrow', monthIndex === item.timePicker.length - 1 && 'disabled']" @click="() => handleChangeSeletor(1)"></div>
                        </div>
                    </div>
                    <!-- <div class="list-title" v-if="source !== 'sun'">排行榜</div> -->
                    <div class="list-content">
                        <div class="no-people" v-if="!list.length && !listLoading">
                            目前还没有人参加哦
                        </div>
                        <ul v-for="(columnKey, columnIndex) in ['seq_num', 'nickname', 'score']" :class="[tab.showTitle && 'has-title']" :key="columnKey">
                            <li v-if="list.length">
                                {{columnsLabel[columnIndex]}}
                            </li>
                            <li
                                v-for="(top, tIndex) in list"
                                :key="tIndex"
                                :data-info="top[columnKey]"
                            >
                                <img v-if="top.seq_num === 1 && !isCurrentMonth && tab.showTitle && columnKey === 'seq_num'" class="title-img" src="http://guokrapp-static.guokr.com/FnCImwX1sV7nzsUUjfIwtK4BAUEi"/>
                                <span>{{top[columnKey]}}</span>
                            </li>
                        </ul>
                    </div>
                    <div :class="['info', userInfoClass]" v-if="!(tab.rankType==='school_score' && user.identity_type!=='student')">
                        <span>{{item.numLabel || '我的排名'}}：{{info.seq_num}}</span>
                        <span>{{item.scoreLabel || '积分'}}：{{info.score}}</span>
                    </div>
                </div>
            </Tab>
        </Tabs>
    </div>
</template>

<script>
import { Tabs, Tab } from 'vant'
import * as config from './config'
import { userApi, rankApi } from '@/apis'
import { throttle } from '@/utils/func'
import { areaList } from '@/components/Auth/Street/config'
import Back from '@/components/Back'

const convertNickname = (nickname) => {
    if (nickname.length === 6 && areaList.province_list[nickname]) {
        // street_code
        return areaList.province_list[nickname]
    } else if (nickname.match(/用户 ([\d*]+)/)) {
        return nickname.match(/用户 ([\d*]+)/)[1]
    } else {
        return nickname
    }
}

export default {
    components: {
        Tabs,
        Tab,
        Back
    },
    data () {
        return {
            listLoading: false,
            tabActive: 0,
            tabs: [],
            list: [],
            user: {},
            monthIndex: 0,
            source: 'sun',
            info: {
                seq_num: null,
                score: null
            },
        }
    },
    computed: {
        tab () {
            return this.tabs[this.tabActive] || {}
        },
        columnsLabel () {
            return this.tab.columnsLabel || ['排名', '手机号', '积分']
        },
        columns () {
            return Object.keys(this.tab.columns || {}).map(key => ({
                key,
                label: this.tab.columns[key]
            }))
        },
        time () {
            return this.tab.timePicker ? this.tab.timePicker[this.monthIndex] : undefined
        },
        isCurrentMonth () {
            return this.time === (new Date().getMonth() + 1)
        },
        userInfoClass () {
            const numLabelLen = this.tab.numLabel?.length || 4,
                scoreLabelLen = this.tab.scoreLabel?.length || 2,
                reqNumLen = (String(this.info.seq_num)?.length || 0) / 2,
                scoreLen = (String(this.info.score)?.length || 0) / 2
            return numLabelLen + scoreLabelLen + reqNumLen + scoreLen > 13 ? 'small' : 'normal'
        }
    },
    watch: {
        tab () {
            this.info = {
                seq_num: null,
                score: null
            }
            this.monthIndex = 0
            this.getTopInfo()
        },
        time () {
            this.info = {
                seq_num: null,
                score: null
            }
            this.getTopInfo()
        }
    },
    methods: {
        async init () {
            await this.getUserInfo()
            this.initTabs()
        },
        async getUserInfo () {
            try {
                const uid = await this.$auth.check({
                    source: this.source
                })
                const { body } = await userApi.userUidGet({
                    params: {
                        uid
                    }
                })
                this.user = body
            } catch {
                console.log('cancel')
            }
        },
        async initTabs () {
            const tabs = []
            for (let i = 0; i < config.tabs[this.source].length; i++) {
                const tab = config.tabs[this.source][i]
                if (typeof tab === 'function') tabs.push(await tab(this.user))
                else tabs.push(tab)
            }
            this.tabs = tabs
        },
        getTopInfo: throttle(async function () {
            this.list = []
            this.listLoading = true
            // list
            const { body: list } = await rankApi.ranksGet({
                params: {
                    limit: this.tab.limit || 50,
                    rank_type: this.tab.rankType,
                    street_code: this.tabActive === 2 ? this.user.street_code : undefined,
                    get_month: this.time ? this.time.value : undefined
                },
                before: (request) => {
                    if (this.previousRequest) this.previousRequest.abort()
                    this.previousRequest = request
                }
            })
            // user
            const { body: myRank } = await rankApi.myRankGet({
                params: {
                    rank_type: this.tab.rankType,
                    street_code: this.tabActive === 2 ? this.user.street_code : undefined,
                    get_month: this.time ? this.time.value : undefined
                },
                before: (request) => {
                    if (this.previousUserRequest) this.previousUserRequest.abort()
                    this.previousUserRequest = request
                }
            })
            this.list = list.map(item => ({
                ...item,
                nickname: convertNickname(item.nickname)
            }))
            this.info = myRank || {}
            this.listLoading = false
        }, 200),
        handleChangeSeletor: throttle(function (num) {
            const endNum = this.monthIndex + num
            if (endNum <= this.tab.timePicker?.length - 1 && endNum >= 0) this.monthIndex = endNum
        }, 200)
    },
    created () {
        this.source = this.$route.query?.source || 'sun'
    },
    mounted () {
        this.init()
    }
}
</script>

<style lang="less" scoped>
#top-page {
    height: 100vh;
    .title {
        text-align: center;
        color: #fff;
        font-size: 18px;
        padding: 1.8rem 0;
    }
    /deep/ .van-tabs {
        height: 100%;
        display: flex;
        flex-direction: column;
        &.agriculture {
            .van-tabs__nav {
                width: 80%;
                margin: 0 auto;
            }
        }
        .van-tab {
            padding: 0 1rem;
            flex-basis: unset!important;
        }
        .van-hairline--top-bottom {
            &::after {
                border: none;
            }
        }
        .van-tabs__wrap {
            flex-shrink: 0;
            .van-tabs__nav {
                background-color: transparent;
                .van-tab {
                    color: #fff;
                    font-size: 15px;
                }
            }
        }
        .van-tabs__content {
            flex: 1;
            display: flex;
            flex-direction: column;
            .van-tab__pane, .top-content {
                max-height: 100%;
                height: 100%;
            }
            .top-content {
                height: calc(100vh - 3.6rem - 27px);
                display: flex;
                flex-direction: column;
                padding: 0.75rem 0 4.4rem;
                box-sizing: border-box;
                .time-picker {
                    .time-picker-content {
                        margin: 1rem 11% 1.5rem;
                        display: flex;
                        flex-direction: row;
                        .left, .right, .time {
                            width: 3.4rem;
                            height: 3.05rem;
                            background-color: #fff;
                            color: #123E7F;
                            font-size: 24px;
                            text-align: center;
                            line-height: 3.05rem;
                            &.disabled {
                                &::before {
                                    color: #fff;
                                }
                                background-color: #D9D9D9;
                            }
                            &::before {
                                color: #123E7F;
                            }
                        }
                        .right {
                            transform: rotateY(180deg);
                        }
                        .time {
                            flex: 1;
                            margin: 0 1rem;
                            font-weight: bolder;
                            font-size: 16px;
                        }
                    }
                }
                .list-title {
                    font-size: 18px;
                    font-weight: bolder;
                    padding: 2rem;
                    background-color: #fff;
                    color: #123E7F;
                    text-align: center;
                    margin: 0 11%;
                    border-bottom: 1px solid #123E7F;
                }
                .list-content {
                    flex: 1;
                    overflow: scroll;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    background-color: #fff;
                    margin: 0 11%;
                    padding: 2rem 2.35rem;
                    .no-people {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 16px;
                    }
                    ul {
                        &:first-child {
                            &.has-title {
                                margin-right: 2.5rem;
                            }
                            li {
                                width: 3.55rem;
                                min-width: auto;
                                position: relative;
                                &[data-info='1'], &[data-info='2'], &[data-info='3'] {
                                    color: #fff;
                                    background-size: cover;
                                    span {
                                        position: relative;
                                        z-index: 2;
                                    }
                                }
                                &[data-info='1'] {
                                    background-image: url(http://guokrapp-static.guokr.com/FkJGLUFHRu2zNk0AD2p68WyTpbWW);
                                }
                                &[data-info='2'] {
                                    background-image: url(http://guokrapp-static.guokr.com/FsBE2xJnk8zJbUtWYbVZzSgGqZZp);
                                }
                                &[data-info='3'] {
                                    background-image: url(http://guokrapp-static.guokr.com/FoXhYRwtKnuLdYX9iStZe7OGyL1g);
                                }
                                &:first-child {
                                    font-weight: normal;
                                }
                            }
                            font-weight: bolder;
                        }
                        li {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            text-align: center;
                            font-size: 15px;
                            color: #123E7F;
                            margin-bottom: 1rem;
                            height: 3.55rem;
                            min-width: 4.5rem;
                            .title-img {
                                display: block;
                                position: absolute;
                                z-index: 1;
                                width: 5rem;
                                left: calc(100% - 1.5rem);
                                top: -1.5rem;
                            }
                        }
                    }
                }
                .info {
                    background-color: #123E7F;
                    margin: 0 11%;
                    color: #fff;
                    font-size: 16px;
                    font-weight: bolder;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    padding: 1.8rem 1.4rem;
                    flex-shrink: 0;
                    &.small {
                        font-size: 15px;
                    }
                }
            }
        }
        .van-tabs__line {
            height: 3px;
            border-radius: 2px;
            background-color: #FFCC2B;
            width: 60px!important;
            transform: translateX(60px) translateX(-50%);
        }
    }
}
</style>
